export default function RiskSection() {
  const riskItems = [
    {
      title: '配送遅延とキャンセルについて',
      content: '本文中に記載させていただいたスケジュールは、あくまでプロジェクト公開時点の予定です。応援購入の性質上、配送遅延のおそれがございます。原則として、配送遅延に伴う応援購入のキャンセルはできませんが、リターン配送予定月から2ヶ月を超えた場合には、希望者に限りキャンセルにて対応させていただきます。',
      icon: 'ri-truck-line'
    },
    {
      title: '商品等の不具合による返品・交換',
      content: '原則として、サポーター都合によるキャンセル・返金は承っておりません。\n（サポーター都合のキャンセル不可の例：サイズ間違い、誤注文、長期不在）',
      icon: 'ri-exchange-line',
      details: [
        {
          label: '対応条件',
          text: '商品の初期不良、またはお届けした商品がご注文内容と異なる場合、到着後14日以内にプロジェクトページの「実行者にメッセージ」よりご連絡ください。確認後、返金または交換対応いたします。'
        },
        {
          label: '返金額',
          text: 'リターン金額（税込）の全額'
        },
        {
          label: '返品送料/再送料',
          text: '実行者負担'
        }
      ]
    },
    {
      title: '返品・交換をお受けできない商品',
      icon: 'ri-close-circle-line',
      list: [
        'サポーターの責任により破損、汚損が生じた商品',
        '商品の付属品やパッケージを紛失、破棄された商品',
        '事前連絡がない商品',
        '商品到着後15日以上経過した商品'
      ]
    },
    {
      title: '交換をお受けできないケース',
      icon: 'ri-information-line',
      list: [
        '限定品や在庫不足により代替品をご用意できない場合'
      ]
    }
  ];

  return (
    <section className="py-24 px-6 bg-[#F8F6FA]">
      <div className="max-w-4xl mx-auto">
        {/* セクションタイトル */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
            <p className="text-sm tracking-[0.3em] text-[#8B6BAE] uppercase">Risk &amp; Challenge</p>
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            リスク&amp;<span className="text-[#8B6BAE]">チャレンジ</span>
          </h2>
          <p className="text-base text-[#6B6B6B] font-light">
            応援購入における注意事項と返品・交換ポリシーについて
          </p>
        </div>

        {/* リスク項目 */}
        <div className="space-y-4">
          {riskItems.map((item, index) => (
            <div key={index} className="bg-white rounded-xl p-6 border border-[#E8E8E8]">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#F0EBF5] shrink-0">
                  <i className={`${item.icon} text-base text-[#8B6BAE]`}></i>
                </div>
                <h3 className="text-base font-medium text-[#2C2C2C] pt-1">{item.title}</h3>
              </div>
              
              {item.content && (
                <p className="text-sm text-[#4A4A4A] leading-relaxed whitespace-pre-line mb-3 pl-12">
                  {item.content}
                </p>
              )}

              {item.details && (
                <div className="space-y-2 mt-3 pl-12">
                  {item.details.map((detail, idx) => (
                    <div key={idx} className="bg-[#F8F6FA] rounded-lg p-3 border border-[#E8E8E8]">
                      <p className="text-xs font-medium text-[#8B6BAE] mb-1 uppercase tracking-wider">{detail.label}</p>
                      <p className="text-sm text-[#4A4A4A] leading-relaxed">{detail.text}</p>
                    </div>
                  ))}
                </div>
              )}

              {item.list && (
                <ul className="space-y-2 mt-2 pl-12">
                  {item.list.map((listItem, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-[#4A4A4A]">
                      <span className="w-1 h-1 bg-[#8B6BAE] rounded-full mt-2 shrink-0"></span>
                      <span className="flex-1">{listItem}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        {/* 最終メッセージ */}
        <div className="mt-10 bg-white rounded-xl p-6 border border-[#8B6BAE]">
          <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
            本プロジェクトは、描く人のための新しいモバイルiPadケーススタンドという挑戦です。
            量産に向けて万全を期しますが、予期せぬ製造・物流上の課題が発生する可能性もございます。
            その際は速やかに活動レポートにて状況をご報告いたします。
          </p>
          <p className="text-base font-medium text-[#8B6BAE] text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
            最後まで責任を持ってお届けいたします。
          </p>
        </div>
      </div>
    </section>
  );
}
